import {checkForRewards} from "../rewards/checkForRewards";
export function addProst(id, commentId, shopUserId, linkElement, commentComment) {
    var container = $("#" + id + ".timeline_entry");
    var tmpCommunityType = 1;  // Standard type timeline
    if (container.hasClass("blog_entry")) {
        tmpCommunityType = 5;  // Blog
    } else if (container.hasClass("event_entry")) {
        tmpCommunityType = 6;  // Events
    } else if (container.hasClass("survey_entry")) {
        tmpCommunityType = 7;  // Survey
    } else if (container.hasClass("ideas_entry")) {
        tmpCommunityType = 8;  // Ideas
    }
    if (commentComment || (id === 0 && commentId !== 0)) {
        tmpCommunityType = 0;
    }
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=add_prost",
        datatype: "json",
        data: {
            "ajax_call_id": id,
            "ajax_call_comment_id": commentId,
            "ajax_call_shop_user_id": shopUserId,
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_community_type_global": communityType,
            "ajax_call_main_language_id": mainLanguageId
        },
        success: function (output) {
            var prostLink = container.find(".prost_link:first");
            var commentContainer = $(".display_comment#comment_" + commentId);
            if (commentComment) {
                commentContainer = $(".display_comment_comment#comment_comment_" + commentId);
                commentContainer.find('.prost_count_comment_comment').text(output);
                prostLink = commentContainer.find(".prost_link");
            } else if (id === 0 && commentId !== 0) {
                commentContainer.find('.prost_count_comment').text(output);
                prostLink = commentContainer.find(".prost_link");
            } else {
                container.find(".prost_count").text(output);
            }


            prostLink.removeClass("prost_link");
            prostLink.addClass("un_prost_link");
            prostLink.addClass("active");
            linkElement.removeClass("clicked");
            checkForRewards(8); // Check for Reward of type Prost
        }
    });
}